module.exports = __webpack_public_path__ + "components/resort-condition/static/next-significant-snowfall-c2723b8cc6e8c39e030ae26ae324b287.svg";